<ng-container *ngIf="isDialogOpened">
  <div class="reportDesignerSaveTemplateDialog">
    <kendo-window [title]="dialogTitle"
                  [width]="500"
                  [minHeight]="330"
                  (close)="cancel()">
      <div class="">

        <loading-indicator [show]="loading"></loading-indicator>

        <div class="dialog-content-container">
          <table aria-hidden="true" style="width: 100%;">
            <tr>
              <td class="dialogLabel dialogTableCellPaddingTop">
                {{ 'reportDesignerDialog.nameOfTemplate' | translate }}
              </td>
              <td style="width:20px;"></td>
            </tr>
            <tr>
              <td class="FieldContainer">
                <kendo-autocomplete class="existingTemplateNamesAutoComplete"
                                    [data]="existingTemplatesNames"
                                    [(ngModel)]="templateName"
                                    [disabled]="!forceNewMode && !saveAs"
                                    placeholder="">
                </kendo-autocomplete>
              </td>
              <td>
                <span *ngIf="!templateNameInvalid" class="requiredMarker">*</span>
                <span *ngIf="templateNameInvalid" class="requiredMarker requiredMarkerInvalid">*</span>
              </td>
            </tr>

            <tr>
              <td class="dialogLabel dialogTableCellPaddingTop">
                {{ 'reportDesignerDialog.templateLanguage' | translate }}
              </td>
              <td style="width:20px;"></td>
            </tr>
            <tr>
              <td class="FieldContainer" *ngIf="templateData">
                <kendo-multiselect [data]="languageChoices"
                                   [(ngModel)]="languageIds"
                                   textField="description"
                                   valueField="id"
                                   [valuePrimitive]="true">
                </kendo-multiselect>
              </td>
              <td>
                <span *ngIf="!languageInvalid" class="requiredMarker">*</span>
                <span *ngIf="languageInvalid" class="requiredMarker requiredMarkerInvalid">*</span>
              </td>
            </tr>

            <tr>
              <td class="dialogTableCellPaddingTop">
                <label class="dialogLabel">
                  {{ 'reportDesignerDialog.saveNewTemplate' | translate }}
                  <input type="checkbox" class="k-checkbox" id="checkboxReportDesignerSaveDialog"
                         [(ngModel)]="saveAs"
                         [attr.disabled]="forceNewMode? true : null"
                         (change)="saveAsChanged()" />
                  <label class="k-checkbox-label" for="checkboxReportDesignerSaveDialog"></label>
                </label>
              </td>
            </tr>

          </table>
        </div>
        <div class="dialog-buttons-container">
          <div class="buttons-bar-border">
            <div class="button-bar">
              <button kendoButton class="button-confirm" (click)="confirm()">{{ 'reportDesignerDialog.save' | translate }}</button>
              <button kendoButton class="button-confirm" (click)="cancel()">{{ 'reportDesignerDialog.cancel' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </kendo-window>
  </div>
  <div class="k-overlay"></div>
</ng-container>
